import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatAutocompleteTrigger, MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { CommonService } from 'src/app-core/services/common.service';
import { CustomerService } from 'src/app/customer/customer.service';
import { PopupService } from '../popup.service';
import { PopupsDataModel } from '../popups-data-model';

@Component({
  selector: 'app-popup-form',
  templateUrl: './popup-form.component.html',
  styleUrls: ['./popup-form.component.scss']
})
export class PopupFormComponent implements OnInit {
  @ViewChild('matAccountAutocomplete', { read: MatAutocompleteTrigger, static: false }) autoComplete: MatAutocompleteTrigger;
  popupsDataModel = new PopupsDataModel();
  popupFormDataModel = this.popupsDataModel.popupModel;
  isFormLoading = false;
  popupData: any;
  accounts = [];
  employees = [];
  employeeName: any;
  expiresOnList = [];
  todayDate = new Date();
  expiryDate = null;
  editData: any;
  accountId: any;

  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<PopupFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MatDialog,
    private commonService: CommonService,
    private accountService: CustomerService,
    private popupService: PopupService) {
    this.popupData = this.data;
  }

  ngOnInit() {
    this.onChangeAccount('');
    this.expiresOnList = this.popupsDataModel.expiresOnList;
    if (this.popupData.isEdit) {
      this.getPopup();
    } else {
      this.popupFormDataModel.expiringOnId = 1;
      this.getEmployees();
    }
    if (this.popupData.accountId) {
      this.accountId = this.popupData.accountId;
      this.getAccountDetails();
    }
  }

  getEmployees(): void {
    this.commonService.getEmployees(this.popupFormDataModel.employeeId || 0).subscribe(response => {
      if (response.isSuccess) {
        this.employees = response.data;
      }
    });
  }

  onChangeAccount(searchText: string, forNewAccount?: boolean): void {
    this.accounts = [];
    this.commonService.getAccounts(searchText).subscribe(response => {
      this.accounts = response.data;
      if (this.accountId) {
        const getAccount = response.data.find(i => i.accountId == this.accountId);
        if (getAccount && !this.popupData.isEdit) {
          this.popupFormDataModel.accountName = getAccount.accountName;
          this.popupFormDataModel.accountId = this.accountId;
        }
      }
    });
  }

  onSetAccountDetails(account: any): void {
    if (account && account.accountId) {
      this.commonService.objectMapping(this.popupFormDataModel, account);
    }
  }

  onBindAccountName(item?: any): string | undefined {
    return item ? item.accountName : undefined;
  }

  onSelectAcountName(value: any) {
    this.popupFormDataModel.accountName = value ? value.accountName : '';
    this.onBindAccountName(value);
  }

  onEmployeeChange(event: any) {
    this.popupFormDataModel.employeeName = event.employeeName;
  }


  onSave() {
    this.popupFormDataModel.employeeId=this.popupFormDataModel.employeeId?this.popupFormDataModel.employeeId:0
    this.popupFormDataModel.expiryDate= this.popupFormDataModel.expiringOnId==2?new Date(this.popupFormDataModel.expiryDate).toLocaleDateString():  null;
     if (!this.popupData.isEdit) {
      this.popupService.popup(this.popupFormDataModel).subscribe(response => {
        if (response.isSuccess) {
          this.dialogRef.close(true);
        }
      });
    } else {
      this.popupFormDataModel;
      this.popupService.updatePopup(this.popupFormDataModel).subscribe(response => {
        if (response.isSuccess) {
          this.dialogRef.close(true);
        }
      });
    }
  }

  getPopup() {
    this.popupService.getPopup(this.popupData.popupData.id).subscribe(response => {
      this.commonService.objectMapping(this.popupFormDataModel, response.data);
      this.getEmployees();
    });
  }

  onClearAccountSelected(event?: any) {
    if (event) {
      event.stopImmediatePropagation();
    }
    this.popupFormDataModel.accountName = '';
    this.popupFormDataModel.accountId = null;
    this.onChangeAccount('');
  }

  onOpenAccountOption() {
    this.autoComplete.openPanel();
  }

  onClose(): void {
    this.dialogRef.close(false);
  }

  onClearDate(event: any): void {
    event.stopPropagation();
    this.popupFormDataModel.expiryDate = null;
  }

  onExpiresOnChange(event: any) {
    this.expiryDate = null;
  }
  
  getAccountDetails() {
    this.accountService.getAccount(this.accountId).subscribe(response => {
        if (response.isSuccess) {
            this.popupFormDataModel.accountName = response.data.accountName;
            this.popupFormDataModel.accountId = this.accountId;
        }
    });
  }

}
